<template>
    <div>
        <v-icon color="primary">mdi-bag-checked</v-icon>
        {{ $t('baggage_allowances') }}
        <span v-if="baggageAllowances.unitQuantity" class="text-success">
            {{
                '(' +
                $t(`baggageAllowances.${baggageAllowances.unitCode}`, {
                    prop: baggageAllowances.unitQuantity,
                }) +
                ')'
            }}
        </span>
        <span
            v-else
            :class="
                baggageAllowances.label === 'partly_available'
                    ? 'text-warning'
                    : baggageAllowances.label === 'is_unavailable'
                      ? 'text-grey'
                      : 'text-error'
            "
        >
            {{ `(${$t('baggageAllowances.' + baggageAllowances.label)})` }}
        </span>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class FlightBaggageAllowances extends Vue {
        @Prop() offer

        get baggageAllowances() {
            if (!this.offer.itinerary[0].segments[0]?.baggageInfo?.length) return {label: 'is_unavailable'}

            const baggage = this.offer.itinerary[0].segments[0].baggageInfo[0].baggage
            const unitQuantity = +baggage.unitQuantity
            const unitCode = baggage.unitCode
            const partlyAvailable = this.offer.itinerary.some(({segments}) =>
                segments.some(
                    ({baggageInfo}) =>
                        baggageInfo &&
                        +baggageInfo[0].baggage.unitQuantity !== unitQuantity &&
                        baggageInfo[0].baggage.unitCode !== unitCode
                )
            )

            if (partlyAvailable) return {label: 'partly_available'}

            return {
                unitQuantity,
                unitCode,
                label: unitQuantity > 0 ? 'included' : 'not_included',
            }
        }
    }

    export default FlightBaggageAllowances
</script>
